var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_2153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_717_2153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_717_2153)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_717_2153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20,
    height: 16,
    fill: "#181818"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_717_2153",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_717_2153",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_717_2153",
    width: 400,
    height: 400,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.97b793020de72412fa194afda8b9a718.svg";
export { ForwardRef as ReactComponent };